import {
    IndicesPanel,
    LatestScanPreview,
    ObservationsPanel,
    formatScanDate,
    scanTakenAt,
    useLatestScanDetail
} from '@odo/shared-ui';
import type { PatientMonitoringBlock, PatientDatesBlock } from '../../../../services/patientCard';
import { dmScansQueryConfig } from '../../../../services/dmScans';
import { Card } from '../shared';

interface ScansCardProps {
    patientId: string;
    monitoring: PatientMonitoringBlock | undefined;
    dates: PatientDatesBlock | undefined;
}

// The preview sizes itself against its parent, so the card owns the height.
const PANEL_HEIGHT = 'flex flex-col min-h-0 h-[28rem]';

function ScansCard({ patientId, monitoring, dates }: ScansCardProps) {
    const dmId = monitoring?.dmId ?? null;
    const { latestScan, detail } = useLatestScanDetail(dmScansQueryConfig, patientId, dmId);

    if (!dmId) {
        return (
            <Card title="Scans">
                <div className="flex items-center justify-center min-h-[120px] text-sm text-gray-400">
                    No Dental Monitoring data for this patient
                </div>
            </Card>
        );
    }

    const dateLabel = latestScan
        ? formatScanDate(scanTakenAt(latestScan))
        : dates?.scansDate
          ? formatScanDate(dates.scansDate)
          : null;

    return (
        <Card title="Scans" subtitle={dateLabel}>
            <div className={PANEL_HEIGHT}>
                <LatestScanPreview
                    queries={dmScansQueryConfig}
                    patientId={patientId}
                    dmId={dmId}
                    hideLabel
                    className="flex-1 min-h-0 flex flex-col gap-3"
                    sidePanel={
                        <>
                            <IndicesPanel measurements={detail?.measurements ?? null} />
                            <ObservationsPanel observations={detail?.observations ?? []} />
                        </>
                    }
                />
            </div>
        </Card>
    );
}

export { ScansCard };
